<template>
    <span v-if="!loading">
        <input :id="packageId"  v-model="package"  class="auto-box" placeholder="กรอกชื่อแพคเกจเพื่อค้นหา" style="width: 100%;">
    </span>
</template>

<script>
import { PackageService } from '../../service'

export default {
    name: "AutoPackage",
    props:{ packageId: String},
    data(){
        return{
            package: "",
            package_id: 0,
            price:0,
            searchTimeout: null,
            loading: true
        }
    },
    async created(){
        this.loading = false
    },
    async mounted(){
        var vm = this
        setTimeout(function(){
            vm.autoPackage(vm.packageId)
        },500)
        
    },
    methods:{
        autoPackage : function(element_id) {
            var vm = this
            document.getElementById(element_id).addEventListener("input", function(e) {
                var self = this
                clearTimeout(vm.searchTimeout)
                vm.searchTimeout = setTimeout(async function(){
                    var a, b, i, val = self.value;
                
                    vm.closeAllLists();
                    if (val.length < 1) { 
                        return false;
                    }
                    vm.currentFocus = -1;
           
                    let position = $(self).position()
                    let width = $(self).width() + 30
                        width = (width > 200 ) ? width : 200

                    a = document.createElement("DIV");
                    a.setAttribute("id", self.id + "autocomplete-list");
                    a.setAttribute("class", "autocomplete-items");
                    a.setAttribute("style",[
                        "left:" + position.left + "px",
                        "top:" + (position.top + 35 )+ "px",
                        "width:" + width + "px"
                    ].join(";"))
            
                    self.parentNode.appendChild(a);

                    let response = await new PackageService().searchName(val)
                   
                    let items = response.result
                    for (var item of items) {
                        b = document.createElement("DIV");
                        b.innerHTML = item.package_name
                        b.innerHTML += "<input type='hidden'  value='" + item.package_name + "'>";
                        b.innerHTML += "<input type='hidden'  value='" + item.package_id + "'>";
                        b.innerHTML += "<input type='hidden'  value='" + item.price + "'>";

                        b.addEventListener("click", function(e) {
                            let package_val = this.getElementsByTagName("input")[0].value
                            let package_id_val = this.getElementsByTagName("input")[1].value
                            let price_val = this.getElementsByTagName("input")[2].value
                            
                            vm.package = package_val
                            vm.package_id = package_id_val
                            vm.price = price_val
                            vm.closeAllLists();
                        });
                        a.appendChild(b);
                    }
                },500)
            });

            document.getElementById(element_id).addEventListener("keydown", function(e) {
                var val = $(this).val()
                if(val.length > 0){
                        var x = document.getElementById(this.id + "autocomplete-list");
                        if (x) x = x.getElementsByTagName("div");
                        if (e.keyCode == 40) {
                            vm.currentFocus++;
                            vm.addActive(x);
                        } else if (e.keyCode == 38) { 
                            vm.currentFocus--;
                            vm.addActive(x);
                        } else if (e.keyCode == 13) {
                            e.preventDefault();
                            if (vm.currentFocus > -1) {
                                if (x) x[vm.currentFocus].click();
                            }
                        }
                }
                
            });
    
            document.addEventListener("click", function (e) {
                vm.closeAllLists(e.target);
            });
        },
        addActive : function(x) {
            if (!x) return false;
                this.removeActive(x);
            if (this.currentFocus >= x.length) this.currentFocus = 0;
            if (this.currentFocus < 0) this.currentFocus = (x.length - 1);
      
            x[this.currentFocus].classList.add("autocomplete-active");
        },
        removeActive : function(x) {
            for (var i = 0; i < x.length; i++) {
                x[i].classList.remove("autocomplete-active");
            }
        },
        closeAllLists:function(elmnt) {
            var x = document.getElementsByClassName("autocomplete-items");
            for (var i = 0; i < x.length; i++) {
                    x[i].parentNode.removeChild(x[i]);
            }
        }
    }
}
</script>

<style scoped>
    .auto-box{
        border: none;
        border-bottom: 1px solid #ddd;
        height: 40px;
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/AutoComplete/AutoPackage.vue